module.exports = __webpack_public_path__ + "img/gift4-01-c10-y1.38a71e1c.png";